import React, { Component } from "react";
import { Input } from "antd";
import { injectIntl } from "react-intl";
import { sendNotification } from "../../../utils/index";

class EditableText extends Component {
  constructor(props) {
    super(props);
    this.inputRef = React.createRef();
    this.state = {
      textContent: props.initialValue,
      oldValue: props.initialValue
    };
  }
  onChange = e => {
    const { onChangeName, path } = this.props;
    const { textContent } = this.state;
    const { intl } = this.props;
    const newText = e.target.value;
    const extensionIndex = newText.lastIndexOf(".");
    let timeout = null;
    if (extensionIndex === -1) {
      sendNotification(
        "info",
        intl,
        intl.formatMessage({ id: "upload-folder-s1-edit" })
      );
      return;
    } else {
      const splitedOld = textContent.split(".")[
        textContent.split(".").length - 1
      ];
      const splitedNew = newText.split(".")[newText.split(".").length - 1];
      if (splitedOld === splitedNew) {
        this.setState({
          oldValue: textContent,
          textContent: newText
        });
        if (onChangeName) {
          clearTimeout(timeout);
          timeout = setTimeout(() => {
            onChangeName(path, newText);
          }, 250);
        }
      } else {
        sendNotification(
          "info",
          intl,
          intl.formatMessage({ id: "upload-folder-s1-edit" })
        );
      }
    }
  };

  componentDidUpdate(prevProps, prevState) {
    if (prevProps.readOnly && !this.props.readOnly) {
      this.inputRef.focus();
      this.inputRef.input.setSelectionRange(0, 0);
    }
  }

  render() {
    const { readOnly, isFolder, intl } = this.props;
    const { textContent } = this.state;

    return (
      <Input
        placeholder={intl.formatMessage({ id: "name" })}
        value={textContent}
        onChange={this.onChange}
        readOnly={readOnly}
        ref={ref => (this.inputRef = ref)}
        style={{
          margin: 0,
          padding: 0,
          border: 0,
          outline: 0,
          // cursor: isFolder ? "pointer" : "text"
          cursor: isFolder ? "pointer" : "pointer"
        }}
      />
    );
  }
}
export default injectIntl(EditableText);
